"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = memoize;

/**
 * 
 * @prettier
 */
function memoize(fn) {
  var called = false;
  var lastInput = null;
  var lastOutput = null;
  return function (input) {
    if (called && input === lastInput) {
      return lastOutput;
    }

    called = true;
    lastInput = input;
    return lastOutput = fn(lastInput);
  };
}